import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getDocItemReplacementLogs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/`, data);
        return await response.data.data;
    } catch (error) {
        console.log("getDocItemReplacementLogs - error", error)
        return handleApiError(error)
    }
}

export const insertDocItemReplacementLog = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertDocItemReplacementLog - error", error)
        return handleApiError(error)
    }
}

export const getDocItemReplacementLogAndMapByDocIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/map`, data);
        return await response.data;
    } catch (error) {
        console.log("getDocItemReplacementLogAndMapByDocIds - error", error)
        return handleApiError(error)
    }
}

export const getDocItemReplacementLogById = async (docItemreplacementLogId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/doc-item-replacement-log/${docItemreplacementLogId}`);
        return await response.data;
    } catch (error) {
        console.log("getDocItemReplacementLogById - error", error)
        return handleApiError(error)
    }
}

export const getDocItemReplacementLogByDocNo = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/docNo`, data);
        return await response.data;
    } catch (error) {
        console.log("getDocItemReplacementLogByDocNo - error", error)
        return handleApiError(error)
    }
}

export const getDocItemReplacementLogByDocId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/docId`, data);
        return await response.data;
    } catch (error) {
        console.log("getDocItemReplacementLogByDocId - error", error)
        return handleApiError(error)
    }
}

export const getDocItemReplacementLogByDocIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/doc-item-replacement-log/docIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getDocItemReplacementLogByDocIds - error", error)
        return handleApiError(error)
    }
}